// extracted by mini-css-extract-plugin
module.exports = {"missing-img-placeholder":"missing-img-placeholder_missing-img-placeholder__Z5xbj"};